/**
 * Sofortiges Skeleton fuer die Kursanzeige, bevor der Monolith bootet.
 * Nutzt window.VivlicoRegistrationOfferGrid (offerGridSkeleton.js), mit
 * Inline-Fallback falls das Skript noch nicht ausgefuehrt wurde.
 */
import type { DisplayRoute } from './urlParse.js';

interface OfferGridApi {
    estimateOfferGridSkeletonCount: (width: number) => number;
    buildOfferGridSkeletonHtml: (count: number) => string;
    shouldShowOfferGridSkeletonFromUrl: (urlArray: string[]) => boolean;
}

function getOfferGridApi(): OfferGridApi | null {
    const api = (globalThis as { VivlicoRegistrationOfferGrid?: OfferGridApi }).VivlicoRegistrationOfferGrid;
    return api && typeof api.buildOfferGridSkeletonHtml === 'function' ? api : null;
}

function inlineSkeleton(count: number): string {
    const card = '<div class="offerCardSkeleton" aria-hidden="true">'
        + '<div class="offerCardSkeleton__image skeletonBlock"></div>'
        + '<div class="offerCardSkeleton__body">'
        + '<div class="skeletonBlock skeletonBlock--title"></div>'
        + '<div class="skeletonBlock skeletonBlock--line"></div>'
        + '<div class="skeletonBlock skeletonBlock--prize"></div>'
        + '</div></div>';
    const n = Math.max(3, Math.min(9, count || 6));
    return `<div class="offerGridSkeleton" data-offer-grid-skeleton="1" aria-busy="true" aria-label="Angebote werden geladen">${card.repeat(n)}</div>`;
}

let rendered = false;

export function renderDisplaySkeleton(route: DisplayRoute): boolean {
    if (rendered || typeof document === 'undefined') return false;
    const main = document.getElementById('mainContent');
    if (!main) return false;
    if (main.childElementCount > 0 || main.innerHTML.trim() !== '') return false;

    const api = getOfferGridApi();
    if (api && !api.shouldShowOfferGridSkeletonFromUrl(route.urlArray)) {
        return false;
    }
    if (route.variant === 'bookingCalendar') {
        return false;
    }
    if (!api && route.isSingleCourse) {
        return false;
    }

    const width = main.getBoundingClientRect().width || window.innerWidth || 1062;
    const count = api ? api.estimateOfferGridSkeletonCount(width) : Math.max(3, Math.min(9, Math.floor((width + 27) / 297) * 2));
    const html = api ? api.buildOfferGridSkeletonHtml(count) : inlineSkeleton(count);

    const container = document.createElement('div');
    container.className = 'offerContainer';
    container.id = 'offerContainer';
    container.innerHTML = html;
    main.appendChild(container);
    rendered = true;
    return true;
}
